module.exports = __webpack_public_path__ + "qa.e211be64bfd527d49f0f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/qa.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/qa.svg
// module chunks = styles